<template>
  <base-dialog @cancel="cancelDialog">
    <div slot="header">{{$t('bill.import_data')}}</div>
    <div slot="body">
      <a-form
        :form="form.fc">
        <a-alert type="warning" class="mb-2">
          <template v-slot:message>
            <div class="messages-list">
              <p>{{ $t('bill.predict_import_tip1') }}<a-button type="link" @click="handleDownloadTemplate">{{$t('system.text_502')}}</a-button></p>
              <p>{{ $t('bill.predict_import_tip2') }}</p>
              <p>{{ $t('bill.predict_import_tip3') }}</p>
            </div>
          </template>
        </a-alert>
        <div class="pt-3 pb-3">
          <a-form-item>
            <a-upload-dragger
              v-decorator="decorators.fileList"
              :beforeUpload="beforeUpload"
              :fileList="fileList"
              :accept="accept"
              :remove="handleRemove">
              <div class="pt-3 pb-3">
                <p class="ant-upload-drag-icon"><a-icon type="inbox" /></p>
                <p class="ant-upload-text">{{$t('system.text_505')}}</p>
                <p class="ant-upload-hint">{{$t('system.text_506')}}</p>
              </div>
            </a-upload-dragger>
          </a-form-item>
        </div>
     </a-form>
    </div>
    <div slot="footer">
      <a-button type="primary" @click="handleConfirm" :loading="loading">{{ $t('dialog.ok') }}</a-button>
      <a-button @click="cancelDialog">{{ $t('dialog.cancel') }}</a-button>
    </div>
  </base-dialog>
</template>

<script>
import * as R from 'ramda'
import XLSX from 'xlsx'
import DialogMixin from '@/mixins/dialog'
import WindowsMixin from '@/mixins/windows'
import { Manager } from '@/utils/manager'

const titleList = ['日期', '数值']
const fieldList = ['day', 'values']

export default {
  name: 'PredictDataImprotDialog',
  mixins: [DialogMixin, WindowsMixin],
  data () {
    return {
      accept: '.xlsx',
      fileList: [],
      loading: false,
      form: {
        fc: this.$form.createForm(this),
      },
      decorators: {
        fileList: ['fileList', {
          rules: [
            { required: true, message: this.$t('system.text_507') },
          ],
        }],
      },
    }
  },
  methods: {
    beforeUpload (file) {
      this.fileList = [file]
      return false
    },
    handleClearFile () {
      this.fileList = []
    },
    handleRemove () {
      this.handleClearFile()
    },
    handleDownloadTemplate () {
      const data = [
        [...titleList],
        ['2023/11/2', 100],
      ]
      const filename = 'predict_template.xlsx'
      const ws_name = 'Sheet1'
      const wb = XLSX.utils.book_new()
      const ws = XLSX.utils.aoa_to_sheet(data)
      ws['!cols'] = [
        { wch: 30 },
        { wch: 30 },
      ]
      XLSX.utils.book_append_sheet(wb, ws, ws_name)
      XLSX.writeFile(wb, filename)
    },
    formatTime (numb) {
      let time
      if (R.is(Number, numb)) {
        time = new Date((numb - 1) * 24 * 3600000 + 1)
        time.setYear(time.getFullYear() - 70)
        return parseInt(this.$moment(time).utc().format('YYYYMMDD'))
      } else {
        time = numb
        return parseInt(this.$moment(time).format('YYYYMMDD'))
      }
    },
    async doCreate (sheetData) {
      try {
        const manager = new Manager('predict_params/upload', 'v1')
        const data = []
        let hasEmpty = false
        sheetData.map(item => {
          const ret = {}
          titleList.map((title, index) => {
            if (['日期'].includes(title)) {
              ret[fieldList[index]] = item[title] ? this.formatTime(item[title]) : ''
            } else {
              ret[fieldList[index]] = [parseInt((item[title] ? item[title] + '' : '').trim())]
            }
          })
          if (!ret.day || !ret.values) {
            hasEmpty = true
          } else {
            data.push(ret)
          }
        })
        if (hasEmpty) {
          this.$message.error(this.$t('bill.predict_import_empty'))
        } else {
          await manager.create({
            data,
          })
          this.cancelDialog()
          this.$message.success(this.$t('common.success'))
          this.params.ok && this.params.ok()
        }
      } catch (error) {
        throw error
      }
    },
    async handleConfirm () {
      try {
        if (!this.fileList || this.fileList.length === 0) {
          this.form.fc.setFieldsValue({
            fileList: undefined,
          })
        }
        const that = this
        await this.form.fc.validateFields()
        this.loading = true
        var fileReader = new FileReader()
        fileReader.onload = async function (ev) {
          try {
            var data = ev.target.result
            var workbook = XLSX.read(data, {
              type: 'binary',
            }) // 以二进制流方式读取得到整份excel表格对象
            var sheetData = [] // 存储获取到的数据
          } catch (e) {
            throw e
          }
          for (var sheet in workbook.Sheets) {
            if (workbook.Sheets.hasOwnProperty(sheet)) {
              sheetData = sheetData.concat(XLSX.utils.sheet_to_json(workbook.Sheets[sheet]))
            }
          }
          that.doCreate(sheetData)
        }
        // 以二进制方式打开文件
        fileReader.readAsBinaryString(this.fileList[0])
      } catch (err) {
        throw err
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

<style lang="less" scoped>
  .messages-list p{
    margin-bottom: 2px;
  }
</style>
